import type { PropsWithChildren } from 'react';

export function PropertyListItem({ children }: PropsWithChildren) {
  return <div className="flex justify-between gap-lg">{children}</div>;
}
PropertyListItem.displayName = 'PropertyListItem';
